// = Libs =
import { FC } from 'react';

// = Styles =

// = Components =
import { EiopHeader } from '@/common/components/eiop/header';
import { PNProvider } from '@n3/pn-core';
import { components, settings, theme } from '@/common/components/eiop/theme';

const Header: FC = () => {
  return (
    <PNProvider theme={theme} components={components} settings={settings}>
      <EiopHeader />
    </PNProvider>
  );
};

export default Header;
